import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import findelement from "../../../../assets/images/docs/findelement.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  findelement,
  React
};